import { WarningIcon } from 'components/Icons/Icons';
import React from 'react';
import cls from 'classnames';
import styles from './Disclaimers.module.scss';

export function EggHatchingWarning({ className }: { className?: string }) {
  return (
    <article className={cls(styles.warning, className)}>
      <WarningIcon />
      <p className={cls('body-default', styles.warningText)}>
        Your eggs are getting hatched... but it&apos;s taking longer than normal. Please check back
        in a few hours
      </p>
    </article>
  );
}

export function EggHatchingWarningHatchening({ className }: { className?: string }) {
  return (
    <article className={cls(styles.unselectWarning, className)}>
      <p className={cls('m-0 body-default text-60')}>
        Please unselect eggs with the
        <span className={styles.warningIcon}>
          <WarningIcon />
        </span>
        icon to continue with hatching
      </p>
    </article>
  );
}
